export enum CustomFieldsServiceErrorCode {
  GENERAL,
}

export interface CustomFieldsServerData {}

export enum CustomFieldsGroup {
  Client = 1,
  Application = 2,
  Committee = 3,
  Loan = 4,
  Collateral = 5,
  Account = 10,
  Obligation = 20, // not sure about the name
}

export enum CustomFieldsSubGroup {
  CollateralSecurity = 1,
  CollateralHypothec = 2,
  CollateralVehicle = 3,
  CollateralDeposit = 4,
  CollateralGuarantee = 5,
  CollateralJewelry = 6,
  CollateralCollateralGroup = 7,
  CollateralEquipment = 8,
  ClientPhysical = 11,
  ClientJuridical = 13,
  ClientGroup = 20,
  ApplicationScreening = 20,
}

export interface CustomFieldsAttributes {
  productId?: number
  subGroupId?: number
  clientType?: number
  collateralType?: number
}

export declare type CustEEItemsActions = 'find' | 'new'
